<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="消防设备" name="first">
      <amend-child-tab />
    </el-tab-pane>
    <el-tab-pane label="水物联设备" name="second">
      <amend-child-tab />
    </el-tab-pane>
    <el-tab-pane label="烟感设备" name="third">
      <amend-child-tab />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import amendChildTab from './amendChildTab.vue'
export default {
  components: { amendChildTab },
  data() {
    return {
      activeName: 'second'
    }
  },
  methods: {
    handleClick(tab, event) {}
  }
}
</script>
